import {useEffect, useRef} from 'react';

const useDisableScroll = (disableScroll: boolean) => {
    const scrollPosition = useRef<null | number>(null);


    useEffect(() => {

        scrollPosition.current = window.scrollY

        const handleScroll = (event: { preventDefault: () => void; }) => {
            if (disableScroll) {
                event.preventDefault();
            } else {
                scrollPosition.current = window.scrollY
            }
        };

        const body = document.body;
        if (disableScroll && (body.scrollHeight > window.innerHeight)) {
            window.scrollTo(0, scrollPosition.current);
            body.style.overflowY = 'scroll';
            body.style.position = 'fixed';
            body.style.top = `-${scrollPosition.current}px`;
            body.style.width = `100%`;
        } else {
            body.style.overflowY = 'auto';
            body.style.position = '';
            body.style.top = '';
            body.style.width = ``;
            window.scrollTo(0, scrollPosition.current);
        }


        document.addEventListener('scroll', handleScroll, {passive: false});

        return () => {
            body.style.overflowY = 'auto';
            body.style.position = 'unset';
            body.style.top = '';
            body.style.width = ``;
            window.scrollTo(0, scrollPosition.current ?? 0);
            document.removeEventListener('scroll', handleScroll);
        };
    }, [disableScroll]);
};


export default useDisableScroll;
